export const today = new Date();

export function get18YearsAgo() {
  return new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()).toISOString().split('T')[0];
}
